import * as http from '../../../vue_shared/http'

/* eslint-disable camelcase */
export interface StripePaymentIntentParams {
  invoice_id: number | string
}

export interface StripePaymentIntent {
  publishable_key: string
  client_secret: string
  payment_intent_id: string
}

export interface StripePaymentConfirm {
  invoice_id: number | string
  payment_intent_id: string
}
/* eslint-enable camelcase */

export async function createStripePaymentIntent(
  params: StripePaymentIntentParams
): Promise<StripePaymentIntent> {
  return http.post<StripePaymentIntentParams, StripePaymentIntent>(
    `/client/payments/stripe_payment_intent`,
    params
  )
}

export async function confirmStripePayment(
  params: StripePaymentConfirm
): Promise<StripePaymentConfirm> {
  return http.post<StripePaymentConfirm, StripePaymentConfirm>(
    `/client/payments/stripe_payment_confirm`,
    params
  )
}
